import React from "react";
import { useIntl } from "react-intl";
import { BRAND_COLOR } from "../constants";

interface ConfirmDialogProps {
	loadingState: boolean;
	loadingMessage?: string;
	show: boolean;
	title: string;
	message: string;
	onYes: () => void;
	onCancel: () => void;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
	loadingState,
	loadingMessage,
	show,
	title,
	message,
	onYes,
	onCancel,
}) => {
	const intl = useIntl();

	return (
		<div
			className={`modal fade ${show ? "show d-block" : "d-none"}`}
			tabIndex={-1}
			role="dialog"
			style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
		>
			<div className="modal-dialog modal-dialog-centered" role="document">
				<div className="modal-content">
					<div className="modal-header">
						<h5 className="modal-title">{title}</h5>
					</div>
					<div className="modal-body">
						{loadingState ? (
							<div className="d-flex align-items-center">
								<div className="spinner-border me-2" role="status">
									<span className="sr-only">{loadingMessage}</span>
								</div>
								<p className="mb-0">{loadingMessage}</p>
							</div>
						) : (
							<p>{message}</p>
						)}
					</div>
					<div className="modal-footer justify-content-end">
						<button disabled={loadingState} className="btn btn-light me-2 col-3" onClick={onCancel}>
							{intl.formatMessage({ id: "cancel" })}
						</button>
						<button
							disabled={loadingState}
							className="btn text-white col-3"
							style={{ backgroundColor: BRAND_COLOR }}
							onClick={onYes}
						>
							{intl.formatMessage({ id: "yes" })}
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ConfirmDialog;
